import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export function Waitlist() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/waitlist", { email, interest: "early-access" });
      setDone(true);
      toast.success("You're on the list.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Something went wrong.");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="mt-8 inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium text-bull"
        style={{ background: "rgba(33,197,142,0.1)", border: "1px solid rgba(33,197,142,0.3)" }} data-testid="waitlist-success">
        <CheckCircle2 size={16} /> You're on the list — we'll email you first when live spots open.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row items-stretch gap-2 max-w-md mx-auto" data-testid="waitlist-form">
      <input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com" data-testid="waitlist-email"
        className="flex-1 rounded-full bg-[var(--surface)] border border-[var(--border2)] px-5 py-3 text-sm outline-none focus:border-aurum" />
      <button type="submit" disabled={busy} data-testid="waitlist-submit"
        className="btn-gold inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold hover:brightness-110 transition-all disabled:opacity-50">
        {busy ? "Joining…" : <>Get early access <ArrowRight size={15} /></>}
      </button>
    </form>
  );
}
